import Scroller from "./Scroller";

const Virtualized = {
  Scroller,
};

export default Virtualized;
